import { render, staticRenderFns } from "./CheckItem.vue?vue&type=template&id=ef33e450&scoped=true&"
import script from "./CheckItem.vue?vue&type=script&lang=js&"
export * from "./CheckItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckItem.vue?vue&type=style&index=0&id=ef33e450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef33e450",
  null
  
)

export default component.exports